export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {

  const limiter = b64Data.indexOf(',');
  const data = b64Data.slice(limiter + 1);
  const byteCharacters = atob(data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
};



// WEBPACK FOOTER //
// ./src/helpers/b64toblob.js